// src/components/common/LoadingSpinner.jsx
// Suspense fallback spinner with EducZa branding

export default function LoadingSpinner({ message = 'Loading...' }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50">
      <div className="flex flex-col items-center gap-4">
        {/* Animated spinner ring */}
        <div className="relative">
          <div className="h-12 w-12 rounded-full border-4 border-slate-200 border-t-[#0d2757] animate-spin" />
        </div>

        {/* Brand text */}
        <div className="text-center">
          <p className="text-lg font-semibold text-[#0d2757] tracking-wide">
            EducZa
          </p>
          <p className="text-sm text-slate-400 mt-1">{message}</p>
        </div>
      </div>
    </div>
  )
}
